import React, { useEffect, useState } from "react";
import { Avatar, Grid, Stack, TextField, Typography } from "@mui/material";
import { digiLockerStatusAPICall } from "../../shared/APICalls";
import JsonStyles from "./JsonData.module.scss";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import MenuIcon from "@mui/icons-material/Menu";
import SideBar from "../SideBar/SideBar";
import ProgressBar from "../ProgressBar/ProgressBar";

interface Props {
  aadhaarData: any;
}

export default function JsonDataToAadhaarFormat({ aadhaarData }: Props) {
  const [fetechedDetails, setfetechedDetails] = useState(true);
  const [expandMenu, setExpandMenu] = useState<any>(false);

  return (
    <>
      {fetechedDetails ? (
        <div className={JsonStyles?.wrapper}>
          <div className={JsonStyles.headerSection}>
            <p className={JsonStyles.header}>
              <div className={JsonStyles.mobileBack}>
                {/* <ArrowBackIosIcon /> */}
              </div>
              Fetched Aadhaar Details
              <div
                className={JsonStyles.mobileMenu}
                onClick={() => {
                  setExpandMenu(!expandMenu);
                }}
              >
                {expandMenu ? <CloseIcon /> : <MenuIcon />}
              </div>
            </p>
            <ProgressBar />
            <div
              className={JsonStyles.mobileexpandedMenu}
              style={{
                height: expandMenu ? "100%" : "0%",
              }}
            >
              <div className={JsonStyles.mobilemenuContent}>
                <SideBar />
              </div>
            </div>
            <p className={JsonStyles.desc}>
              Please review your Aadhaar details and verify to proceed
            </p>
          </div>
          <div className={JsonStyles.containerData}>
            <Grid
              margin={"0px 0"}
              sx={{
                borderRadius: "50%",
                border: { xs: "none", sm: "1px solid #E5E7EB" },
                width: "110px",
                height: "110px",
                transform: "rotate(45deg)",
                // position: "absolute",
                // top: "-50px",
              }}
            >
              <img
                src={aadhaarData?.url}
                alt="Certificate"
                style={{
                  width: "100px",
                  height: "100px",
                  border: "5px solid white",
                  borderRadius: "50%",
                  transform: "rotate(-45deg)",
                }}
              />
            </Grid>
            <Grid
              container
              rowSpacing={{ xs: 2, sm: 6 }}
              columnSpacing={{ xs: 1, sm: 2, md: 5 }}
            >
              <Grid item xs={12} sm={3}>
                <div className={JsonStyles.itemWrap}>
                  <div className={JsonStyles.labeltext}>Aadhaar No</div>
                  <div className={JsonStyles.value}>
                    {aadhaarData?.aadhaar_no}
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={JsonStyles.itemWrap}>
                  <div className={JsonStyles.labeltext}>Name</div>
                  <div className={JsonStyles.value}>{aadhaarData?.name}</div>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={JsonStyles.itemWrap}>
                  <div className={JsonStyles.labeltext}>Date of Birth</div>
                  <div className={JsonStyles.value}>{aadhaarData?.dob}</div>
                </div>
              </Grid>
              <Grid item xs={12} sm={3}>
                <div className={JsonStyles.itemWrap}>
                  <div className={JsonStyles.labeltext}>Gender</div>
                  <div className={JsonStyles.value}>{aadhaarData?.gender}</div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <div className={JsonStyles.labeltext}>Address</div>
                <div className={JsonStyles.value}>{aadhaarData?.address}</div>
              </Grid>
            </Grid>
          </div>
        </div>
      ) : (
        <Stack>
          <Typography>No Details Fetched</Typography>
        </Stack>
      )}
    </>
  );
}
